import React from 'react';
import ReactDOM from 'react-dom/client';
import {TravelProvider} from './TravelContext';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import i18n from './i18n';
import 'react-date-range/dist/styles.css'; // react-date-range main style file
import 'react-date-range/dist/theme/default.css'; // react-date-range theme css file
import App from './App';
import reportWebVitals from './reportWebVitals';

import { AuthProvider } from './context/AuthContext';

// Initialize theme before React renders
(() => {
  try {
    const saved = localStorage.getItem('theme');
    const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    const theme = saved || (prefersDark ? 'dark' : 'light');
    const html = document.documentElement;
    if (theme === 'dark') html.classList.add('dark'); else html.classList.remove('dark');
    // language from settings
    const raw = localStorage.getItem('seyHot_settings');
    if (raw) {
      const s = JSON.parse(raw);
      if (s && s.language) i18n.changeLanguage(s.language);
    }
  } catch {}
})();

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <TravelProvider>        {/* 1) seyahat deposu */}
        <BrowserRouter>       {/* 2) sayfa geçişleri */}
          <App />
        </BrowserRouter>
      </TravelProvider>
    </AuthProvider>
  </React.StrictMode>
);


reportWebVitals(console.log);
